import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/stores";
import { DashboardData, DashboardService } from "@/domains/dashboard";

interface tenantDashboardState {
  loading: boolean;
  data?: DashboardData;
}

const initialState: tenantDashboardState = {
  loading: false,
  data: undefined,
};

export const tenantDashboardSelects = {
  loading: (state: RootState) => state.tenantDashboard.loading,
  data: (state: RootState) => state.tenantDashboard.data,
};

export const tenantDashboardThunks = {
  read: createAsyncThunk("tenantDashboard/read", async () => {
    const res = await DashboardService.read().run();
    return res.data.msg;
  }),
};

export const tenantDashboardSlice = createSlice({
  name: "tenantDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(tenantDashboardThunks.read.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(tenantDashboardThunks.read.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(tenantDashboardThunks.read.rejected, (state) => {
      state.loading = false;
      state.data = undefined;
    });
  },
});

export const tenantDashboardActions = tenantDashboardSlice.actions;
